import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import LoginForm from './LoginForm';
import ForgotForm from './ForgotForm';

const DISPLAY_FORM = {
  LOGIN: 'login',
  FORGOT: 'forgot',
};

export default function LoginForgotForms({ redirectLink, logo, onLoggedIn, ignoreRedirection }) {
  const containerId = 'm_login';
  const [formDisplayed, setFormDisplayed] = useState(DISPLAY_FORM.LOGIN);

  useEffect(
    () => {
      const container = (() => {
        switch (formDisplayed) {
          case DISPLAY_FORM.FORGOT:
            return '.m-login__forget-password';
          case DISPLAY_FORM.LOGIN:
          default:
            return '.m-login__signin';
        }
      })();

      $(`#${containerId}`)
        .find(container)
        .animateClass('flipInX animated');
    },
    [formDisplayed],
  );

  const displayLoginForm = () => setFormDisplayed(DISPLAY_FORM.LOGIN);
  const displayForgotPasswordForm = () => setFormDisplayed(DISPLAY_FORM.FORGOT);

  const containerClasses = cx(
    'm-login-container',
    'm-login__logo',
    { 'm-login--signin': formDisplayed === DISPLAY_FORM.LOGIN },
    { 'm-login--forget-password': formDisplayed === DISPLAY_FORM.FORGOT },
  );

  return (
    <div className={containerClasses} id={containerId}>
      {logo && <img src={logo} alt="logo" className="login-logo" />}
      <LoginForm
        redirectLink={redirectLink}
        displayForgotPassword={displayForgotPasswordForm}
        onLoggedIn={onLoggedIn}
        ignoreRedirection={ignoreRedirection}
      />
      <ForgotForm displayLoginForm={displayLoginForm} />
    </div>
  );
}

LoginForgotForms.propTypes = {
  redirectLink: PropTypes.string.isRequired,
  logo: PropTypes.string.isRequired,
  onLoggedIn: PropTypes.func,
  ignoreRedirection: PropTypes.bool,
};

LoginForgotForms.defaultProps = {
  onLoggedIn: null,
  ignoreRedirection: null,
};
